import { restClient } from '@/Core/Services/RestClientService'
import type { DashboardPerformance, DashboardPeriod, DashboardSummary } from '@/Ship/Contracts/DashboardSummary'

const dispatcherParams = (dispatcherId: number | null | undefined): Record<string, string> =>
    dispatcherId ? { dispatcherId: String(dispatcherId) } : {}

/**
 * Лічильники головної: воронки, «Потребує уваги», активні затримки. `dispatcherId` звужує
 * всі блоки до одного диспетчера (бекенд ігнорує його для звичайного диспетчера).
 * Кеш вимкнено — головна оновлюється щохвилини. Кидає помилку ky — показує викликач.
 */
export const LoadDashboardSummaryTask = async (dispatcherId?: number | null): Promise<DashboardSummary> => {
    const req = restClient.get<DashboardSummary>(
        '/services/dashboard/summary',
        { searchParams: dispatcherParams(dispatcherId) },
        { forceRefresh: true }
    )
    if (!req) throw new Error('Не вдалося сформувати запит')
    return (await req) as unknown as DashboardSummary
}

/** Показники за період (поточний і попередній відрізок) і динаміка за 30 днів */
export const LoadDashboardPerformanceTask = async (
    period: DashboardPeriod,
    dispatcherId?: number | null
): Promise<DashboardPerformance> => {
    const req = restClient.get<DashboardPerformance>(
        '/services/dashboard/performance',
        { searchParams: { period, ...dispatcherParams(dispatcherId) } },
        { forceRefresh: true }
    )
    if (!req) throw new Error('Не вдалося сформувати запит')
    return (await req) as unknown as DashboardPerformance
}
